import React, { useState, useEffect } from "react"

import {
  Card,
  CardBody,
  Col,
  Row,
  CardTitle,
  Alert,
  Label,
  Input,
  Button
} from "reactstrap"

import { AvForm, AvField } from "availity-reactstrap-validation"
import { post, put, get } from '../../helpers/api_helper';
import Utils from '../Utility';
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import Multiselect from 'multiselect-react-dropdown';

const AddUserForm = (props) => {
  const { user, data, role, loading, setLoading } = props;
  const [successMsg, setSuccessMsg] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [projects, setProjects] = useState([]);
  const [isError, setIsError] = useState(false);
  const [selectedProj, setSelectedProj] = useState([]);
  const [isPassShow, setIsPassShow] = useState(false);

  useEffect(() => {
    if (props.user) {
      console.log('user on add user', props?.project);
      getProjects();
    }
  }, [props, data]);

  const getProjects = () => {
    if (user?.companyId) {
      get("/project/list?companyId=" + user?.companyId, { token: user?.token })
        .then(json => {
          console.log('response from get user list', json);
          let proj = [];
          let select = [];
          json.data.map((item) => {
            proj.push({ name: item?.name, id: item?._id });
            if (item?.dealers?.length > 0) {
              console.log('found dealer', item?.dealers[0]);
              const found = item?.dealers?.findIndex(x => x == data?._id);
              console.log('found dealer', found);
              if (found != -1) {
                select.push({ name: item?.name, id: item?._id });
              }
            }
          });
          console.log('selected proj', select);
          setProjects(proj);
          setSelectedProj(select);
          if (props?.project) {
            let proj = [];
            proj.push({ id: props?.project?._id });
            setSelectedProj(proj);
          }
        })
        .catch(error => {
          console.log('error while getting user list', error);
        });
    } else {
      setErrorMsg("Ask your Admin to create a project first!");
    }
  }

  async function handleValidSubmit(event, values) {
    console.log('values from form', values);
    if (user?.companyId) {
      if (data) {
        //updating user
        if (selectedProj?.length < 1) {
          setIsError(true);
          return;
        }
        let projectIds = [];
        selectedProj.map((item) => {
          projectIds.push(item?.id);
        });
        const body = {
          ...values,
          projectIds,
          token: user?.token,
          user_id: data?._id
        };
        setLoading(true);
        let url = "/moderator/update";
        if (role == 'Dealer')
          url = "/dealer/update";
        put(url, body)
          .then((json) => {
            console.log('response from updating user', json);
            setLoading(false);
            if (json.statusCode == 200) {
              setSuccessMsg(json?.message);
              setErrorMsg(null);
              props.close(false);
            } else {
              setErrorMsg(json?.error);
              setSuccessMsg(null);
            }
          })
          .catch(error => {
            console.error('error while adding user', error);
            setErrorMsg('Something Went Wrong!');
            setSuccessMsg(null);
            setLoading(false);
          })
      } else {
        //adding new user
        if (selectedProj?.length < 1 && props?.type != 'project' && props?.type != 'lead') {
          setIsError(true);
          return;
        }
        let projectIds = [];
        selectedProj.map((item) => {
          projectIds.push(item?.id);
        })
        const body = {
          ...values,
          projectIds,
          addedBy: user?._id,
          token: user?.token,
          companyId: user?.companyId,
          userName: user?.name,
          companyName: user?.company?.name
        };
        let url = "/moderator/add";
        if (role == 'Dealer')
          url = "/dealer/add";
        setLoading(true);
        post(url, body)
          .then((json) => {
            console.log('response from adding user', json);
            setLoading(false);
            if (json.statusCode == 200) {
              toast.success(json?.message);
              if (role == 'Dealer' && props?.setCurrentDealer)
                props?.setCurrentDealer(json?.data?._id);
              if (props?.getProfile)
                props?.getProfile({ user: user });
              setSuccessMsg(json?.message);
              setErrorMsg(null);
              props.close(false);
              if (props?.getProjects)
                props?.getProjects();
            } else {
              toast.error(json?.error);
              setErrorMsg(json?.error);
              setSuccessMsg(null);
            }
          })
          .catch(error => {
            console.error('error while adding user', error);
            setErrorMsg('Something Went Wrong!');
            setSuccessMsg(null);
            setLoading(false);
          })
      }
    }
  }

  const onSelect = (selectedList, selectedItem) => {
    console.log('on select ', selectedList, selectedItem);
    setSelectedProj(selectedList);
    if (selectedList?.length > 0)
      setIsError(false);
  }

  const onRemove = (selectedList, removedItem) => {
    console.log('remove item', selectedList, removedItem);
    setSelectedProj(selectedList);
    if (selectedList?.length < 1)
      setIsError(true);
  }

  return (
    <React.Fragment>
      <div className="">
        <Row>
          <Col>
            {errorMsg &&
              <Alert color="danger">{errorMsg}</Alert>
            }
            {successMsg &&
              <Alert color="success">{successMsg}</Alert>
            }
            <Card>
              <CardBody>
                <Loader loading={loading} />
                <div className="">
                  <div className="d-flex" style={{ marginLeft: 'auto' }}>
                    <div>
                      <CardTitle className="h4">{data ? 'Update' : 'Add New'} {props.role == 'Dealer' ? 'Channel Partners' : props?.role}</CardTitle>
                      {props?.role == 'Moderator' ?
                        <p className="card-title-desc">
                          This <code>{props.role}</code> Will be {data ? 'updated' : 'added'} to your company for Managing <code>leads</code> and <code>Channel Partners</code>.
                        </p>
                        :
                        <p className="card-title-desc">
                          This <code>Channel Partners</code> Will be added to your company for Managing <code>leads.</code>
                        </p>
                      }
                    </div>
                    <div className="text-center" style={{ marginLeft: 'auto' }}>
                      <Button color="primary" onClick={() => { props?.setCurrentUser(null); props?.close(false) }} style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor }}>
                        {props?.type == 'project' ? 'Skip' : 'Close'}
                      </Button>
                    </div>
                  </div>
                  <AvForm
                    className="form-horizontal"
                    onValidSubmit={(e, v) => {
                      handleValidSubmit(e, v)
                    }}
                  >
                    {props?.role == 'Dealer' && props?.type != 'project' && props?.type != 'lead' &&
                      <div className="form-group mb-4">
                        <Multiselect
                          style={{
                            searchBox: {
                              border: isError ? '1px solid #ff715b' : ''
                            }
                          }}
                          options={projects} // Options to display in the dropdown
                          selectedValues={selectedProj} // Preselected value to persist in dropdown
                          onSelect={onSelect}   // Function will trigger on select event
                          onRemove={onRemove} // Function will trigger on remove event
                          displayValue="name" // Property name to display in the dropdown options
                          placeholder={"Select Project"}
                          showCheckbox
                          name="project"
                          label={"Projects"}
                        />
                        {isError &&
                          <span style={{ color: '#ff715b', fontSize: 12 }}>This field is invalid</span>
                        }
                        {/* <AvField
                          name="projectId"
                          label={"Select Project"}
                          value={data?.projectId}
                          className="form-control"
                          placeholder={`Select Project`}
                          type="select"
                          required
                        >
                          <option value={""} >Select Project</option>
                          {projects.map(item => (
                            <option value={item?._id} key={item?._id} >{item.name}</option>
                          ))}
                        </AvField> */}
                      </div>
                    }
                    <div className="form-group mb-4">
                      <AvField
                        name="name"
                        label={"Name"}
                        value={data?.name}
                        className="form-control"
                        placeholder={`Enter Name`}
                        type="text"
                        required
                      />
                    </div>
                    <div className="form-group mb-4">
                      <AvField
                        name="email"
                        label={"Email"}
                        value={data?.email}
                        className="form-control"
                        placeholder={`Enter Email`}
                        type="email"
                        required
                        disabled={data ? true : false}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <AvField
                        name="mobile"
                        label={"Mobile"}
                        value={data?.mobile}
                        className="form-control"
                        placeholder={`Enter Mobile`}
                        type="text"
                        required
                        validate={{ minLength: { value: 10 }, maxLength: { value: 10 } }}
                      />
                    </div>
                    {role == 'Dealer' &&
                      <div className="form-group mb-4">
                        <AvField
                          name="address"
                          label={"Address"}
                          value={data?.address}
                          className="form-control"
                          placeholder={`Enter Address`}
                          type="text"
                          required
                        />
                      </div>
                    }
                    {!data &&
                      <div className="form-group" style={{ position: 'relative' }}>
                        <AvField
                          name="password"
                          label={"Password"}
                          value={data?.password}
                          className="form-control"
                          placeholder={`Enter Password`}
                          type={isPassShow ? "text" : "password"}
                          required
                          validate={{ minLength: { value: 6 } }}
                        />
                        <i className={`mdi ${isPassShow ? 'mdi-eye-off' : 'mdi-eye'}`} style={{ fontSize: 20, position: 'absolute', top: 34, right: 30, cursor: 'pointer' }}
                          onClick={() => setIsPassShow(!isPassShow)}
                        ></i>
                      </div>
                    }
                    {/* <AvField name="idx" value={user?.company._id} type="hidden" /> */}
                    <div className="text-center mt-4">
                      {data ?
                        <Button type="submit" color="primary" style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor }}>
                          Update {props.role == 'Dealer' ? 'Channel Partners' : props.role}
                        </Button>
                        :
                        <Button type="submit" color="primary" style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor }}>
                          Add {props.role == 'Dealer' ? 'Channel Partners' : props.role}
                        </Button>
                      }
                    </div>
                  </AvForm>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

export default AddUserForm;
